<template>
    <div class="template6-list-agent-card">
        <div class="template6-avatar-box">
            <a  :href="redirectUrl"
                :target="detailUrlTarget"
                rel="noopener noreferrer">
                <AgentHeadShot class="avatar" :headshots="agent.headShots" :initImage="agent.image" :alt="agent.fullName || 'agent image'" keyClass="md-team-template6-list"></AgentHeadShot>
            </a>
            <Share :socialNetworks="agent.agentSocialNetworks" />
        </div>
        <div class="agent-info">
            <h5 v-if="agent.fullName">{{ agent.fullName }}</h5>
            <p v-if="agent.position">{{ agent.position }}</p>
        </div>
    </div>
</template>

<script>
import agentInfo from '../agent-info';
import Share from './share';
import AgentHeadShot from '@/components/agent-headshot.vue'
export default {
    props: {
        agent: {
            type: Object,
            required: true
        },
        detailUrlTarget: {
            type: String,
            default: '_self'
        }
    },
    components: { Share, AgentHeadShot },
    mixins: [agentInfo]
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.template6-list-agent-card {
    width: fit-content;
    .template6-avatar-box {
        position: relative;
    }
    .avatar {
        width: 235px !important;
        height: 240px !important;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
        &::after {
            content: '';
            background-color: rgba(25, 25, 25, 0.5);
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            border-radius: 50%;
        }
        &:hover:after {
            display: none;
        }
    }
    .share-links {
        position: absolute;
        bottom: 15px;
        display: none;
    }
    .agent-info {
        margin-top: 18px;
        text-align: center;
        h5 {
            font-size: 16px;
            line-height: 30px;
            font-family: var(--font-normal);
            color: #fff;
            margin: 0;
        }
        p {
            margin-top: 2px;
            font-size: 12px;
            line-height: 12px;
            font-family: var(--font-normal);
            color: #fff;
        }
    }
    &:hover {
        .share-links {
            display: block;
        }
    }
    @include media-600 {
        .avatar {
            width: 160px !important;
            height: 160px !important;
        }
        .share-links {
            position: absolute;
            bottom: 10px;
        }
        .agent-info {
            margin-top: 10px;
            h5 {
                font-size: 14px;
                line-height: 30px;
            }
            p {
                font-size: 12px;
                line-height: 12px;
            }
        }
    }
}
</style>
